// extracted by mini-css-extract-plugin
export default {"image":"AboutMe_image__YkFy6","aboutMe":"AboutMe_aboutMe__2u9qL","row":"AboutMe_row__DYhRY","flex":"AboutMe_flex__rTzaD","column":"AboutMe_column__tNWlN"};